<div class="container-fluid">
    <div class="row tabs justify-content-around text-center">
        
        <div class="col tab col-3">
            <button mat-raised-button color="primary" (click)="goNewPlan()">
                <p>Create New Plan</p>
            </button>
        </div>
        <div class="col tab col-3">
            <button mat-raised-button color="primary" (click)="goAllPlans()">
                <p>View All Plans</p>
            </button>
        </div>
        <div class="col tab col-2">
            <button mat-raised-button color="primary" (click)="goManageUsers()">
                <p>Users</p>
            </button>
        </div>
        <div class="col tab col-2">
            <button mat-raised-button color="primary" (click)="goManageOrders()">
                <p>Orders</p>
            </button>
        </div>
        <div class="col tab col-2">
            <button mat-raised-button color="primary" (click)="goMessages()">
                <p>Messages</p>
            </button>
        </div>
                
    </div>

    <div class="row details justify-content-center">
        <div class="col col-12">
            <router-outlet></router-outlet>
        </div>
    </div>
    <div class="row justify-content-center mt-3">
        <div class="col-2"><button mat-raised-button color="primary" class="text-center pt-0" (click)='logOut()'>Log Out</button></div>
    </div>
</div>